// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, throwError } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Models
import { User, UserHelper } from '../../models/b2b/user';

// Helpers
import { Base64 } from './../../lib/helpers/utils';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class ZonaInfoService {
    // TODO @dani interfaz tipo documento $dani
    favorites: any[] = [];
    // isFavourite: boolean = false;

    constructor(private api: ApiService) {}

    getTree2(user: User, filter: any = undefined): Observable<any[]> {
        // Params
        const params = [];
        params['DIRECCIONENVIO'] = UserHelper.getAddressCodeDefault(user);

        if (filter) {
            Object.keys(filter).forEach((key) => {
                switch (key) {
                    case 'NUEVO':
                        params['NUEVO'] = filter[key];
                }
            });
        }

        return this.api.callSoledad('b2bNew.dbo.HTML_DocumentosLeer', params).pipe(
            validateApiResponse('Error obteniendo documentos' + '. Params: ' + JSON.stringify(params)),
            map((res: any) => {
                return res;
            })
        );
    }

    getTree(user: User, filter: any = undefined): Observable<any[]> {
        // Params
        const params = [];
        params['DIRECCIONENVIO'] = UserHelper.getAddressCodeDefault(user);

        if (filter) {
            Object.keys(filter).forEach((key) => {
                switch (key) {
                    case 'NUEVO':
                        params['NUEVO'] = filter[key];
                }
            });
        }

        return this.api.callSoledad('b2bNew.dbo.HTML_DocumentosLeer', params).pipe(
            validateApiResponse('Error obteniendo documentos' + '. Params: ' + JSON.stringify(params)),
            map((res: any) => {
                // console.log('b2bNew.dbo.HTML_DocumentosLeer', res);
                if (res) {
                    let docs = [];
                    let pathTemp = [];
                    let l = 0;
                    let activeNode = null;
                    this.favorites = [];

                    for (let item of res) {
                        pathTemp = item.RELATIVEPATH.split('/');
                        activeNode = docs;
                        l = pathTemp.length;

                        if (item.FAVORITO == 1) {
                            this.favorites.push({
                                label: item.FILE.replace(/\.[^/.]+$/, ''),
                                data: item,
                                type: this.getType(item.FILE)
                            });
                        }

                        for (var i = 0; i < l; i++) {
                            if (i == l - 1) {
                                //last node
                                if (!activeNode['leaves']) activeNode['leaves'] = [];

                                activeNode['leaves'].push(item);
                            } else {
                                if (!activeNode[pathTemp[i]]) activeNode[pathTemp[i]] = [];

                                activeNode = activeNode[pathTemp[i]];
                            }
                        }
                    }
                    let tree = this.addNodeToTree(docs, 0);
                    // console.log({tree});
                    return tree;
                }
                ////
                // return res.value.map(row => AddressHelper.transformFromAPI(row));
                return res; //
            })
        );
    }

    addNodeToTree(node, depth) {
        var children = [];

        for (var key in node) {
            if (key !== 'leaves')
                children.push({
                    label: key.replace(/\.[^/.]+$/, ''),
                    children: this.addNodeToTree(node[key], depth + 1),
                    type: 'folder',
                    icon: key
                });
            else {
                var leaves = [];
                var l = node[key].length;
                for (var i = 0; i < l; i++)
                    children.push({
                        label: node[key][i].FILE.replace(/\.[^/.]+$/, ''),
                        data: node[key][i],
                        type: this.getType(node[key][i].FILE)
                    });
            }
        }

        return children;
    }

    getType(file) {
        var split = file.split('.');
        var type = '';

        // Type
        if (split.length > 1) {
            type = split[split.length - 1].toLowerCase();
            if (type.search(/xls/g) >= 0) {
                type = 'xls';
            }
            if (type.search(/doc/g) >= 0) {
                type = 'doc';
            }
        }
        if (!['xls', 'pdf', 'doc', 'jpg'].includes(type)) {
            type = 'other';
        }
        return type;
    }

    getFavoritos(): any[] {
        return this.favorites;
    }

    setFavorito(file: any, favorito: boolean): Observable<any[]> {
        ////
        // Parámetros
        var params = [];
        params['DOCUMENTO'] = encodeURIComponent(Base64.encode(file.data.RELATIVEPATH));
        params['NOMBRE_FAVORITO'] = '';
        params['TIPO_FAVORITO'] = '';

        // Eliminación
        if (!favorito) {
            params['ELIMINADO'] = 1;
        }
        return this.api.callSoledad('b2bNew.dbo.HTML_Documentos_Favorito', params).pipe(
            map(
                (res) => {
                    try {
                        if (!res.value || res.value.length === 0) {
                            throw new Error('Error to obtain data');
                        }

                        if (res.result === 0) {
                            if (favorito) {
                                // Si el item no existe ya en la lista de favs.
                                let existe = this.favorites.findIndex(
                                    (x) => x.label === file.label && x.data.PATH === file.data.PATH
                                );
                                if (existe < 0) this.favorites.push(file);
                            } else {
                                var indexFeatured = -1;
                                for (let index = 0; index < this.favorites.length; index++) {
                                    if (this.favorites[index].label == file.label) {
                                        //
                                        indexFeatured = index;
                                    }
                                }
                                if (indexFeatured >= 0) {
                                    this.favorites.splice(indexFeatured, 1);
                                }
                            }
                        }
                        return res; //
                    } catch (error) {
                        console.error(error);
                        throwError(error.message);
                    }
                },
                (error) => console.log({ error })
            )
        );
    }
}
